export enum PackageKeys {
  JUNIOR = 'junior',
  MEDIOR = 'medior',
  SENIOR = 'senior',
}
